// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//urls should be in the format of [protocol]://[fqdn]{:port}{/common path}
//example:
//if the documents API exists at https://eqms-documents.azurewebsites.net/api/documents
//then here the entry would look like: https://eqms-documents.azurewebsites.net/api/

let environmentName = "staging-s002";
let prefix = "https://";
let suffix = ".eqms.eu.eurofinsbpt.com/api/";

let documentsApi = prefix + "documents." + environmentName + suffix;
let delegatesApi = prefix + "delegates." + environmentName + suffix;
let assignmentGroupsApi = prefix + "assignment-groups." + environmentName + suffix;
let trainingApi = prefix + "training." + environmentName + suffix;
let administrationApi = prefix + "administration." + environmentName + suffix;
let changeControlApi = prefix + "changemanagement." + environmentName + suffix;
let recordKPRApi = prefix  + "recordkpr." + environmentName + suffix;
let skillsApi = prefix + "skill." + environmentName + suffix;

export const environment = {
  production: true,
  urls: {
    apis: {
      documents: documentsApi,
      documentAttachments: documentsApi,
      changeRequests: documentsApi,
      hardCopyActivities: documentsApi,
      dependencies: "https://famsidentity.lims.stag.eurofinsbpt.org/Carbon//api/",
      files: "https://files.staging-s002.eqms.eu.eurofinsbpt.com/api/",
      delegates: delegatesApi,
      assignmentgroups: assignmentGroupsApi,
      courses: trainingApi,
      boron: "https://app-eqms-shared-dependencies-boron-staging-s002.azurewebsites.net/api/",
      administration: administrationApi,
      changeControl: changeControlApi,
      recordKPR: recordKPRApi,
      skills: skillsApi
    }
  },
  surveyJsProductKey:"ZDBlYWZjYmMtYTg2Mi00M2ZlLTg4MWUtMWJkMmMwY2ViNjI0OzE9MjAyNC0xMC0xMCwyPTIwMjMtMDItMDc=",
  retryAttempts:3,
  limitedDashboardProfile: false
};  